import Awards from './Awards';

export default Awards;
